import { Box, Button } from "@mui/material";
import axios from "axios";
import { useHistory } from "react-router";
import useAuthStore from "../../../../store/login/useAuthStore";

export default function Profile() {
  const history = useHistory();
  const accessToken = useAuthStore((store) => store.accessToken);
  const setAccessToken = useAuthStore((store) => store.setAccessToken);
  const setName = useAuthStore((store) => store.setName);
  const setFamily = useAuthStore((store) => store.setFamily);
  const headers = {
    "Content-Type": "application/json",
    "x-user-agent": "12345dddd",
    "x-app-token": "xtf9rTlupdsf234A2XSxyMffgmfbJckG",
    "x-app-id": "123456",
    "Authorization": `Bearer ${accessToken}`
  };
  
  const handleLogout = (e) =>{
    e.preventDefault();
    axios.get('https://kimia-shop.ir/api/web/v1/user/logout' , {headers});
    history.push('/');
    setAccessToken('');
    setName('');
    setFamily('');
    localStorage.clear();
  }
  return (
    <Box p={4} textAlign="center">
      <Button variant="contained" onClick={handleLogout}>
        خروج از سیستم
      </Button>
    </Box>
  );
}
